import React, { useContext, useState, useEffect } from "react";

import AuthContext from "../../Contexts/Autenticacion/authContext";
import AlertsContext from "../../Contexts/Alertas/AlertasContext";
const SingIn = (props) => {
  const { mostrarAlerta } = useContext(AlertsContext);
  const { iniciarSesion, autenticado } = useContext(AuthContext);
  useEffect(() => {
    if (autenticado) {
      props.history.push("/dashboard");
    }
  }, [autenticado]);
  const [dataLogin, setDataLogin] = useState({
    email: "",
    password: "",
  });
  const onChangeDataUser = (e) => {
    setDataLogin({ ...dataLogin, [e.target.name]: e.target.value });
  };

  const validateLogin = (e) => {
    e.preventDefault();

    if (dataLogin.email.trim() === "" || dataLogin.password.trim() === "") {
      mostrarAlerta("Faltan campos", "error");
      return;
    }
    iniciarSesion(dataLogin);
  };
  return (
    <div className="container min-vh-100 d-flex justify-content-center align-items-center">
      <form>
        <div className="form-group">
          <label htmlFor="exampleInputEmail1">Email address</label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            name="email"
            aria-describedby="emailHelp"
            onChange={onChangeDataUser}
          />
          <small id="emailHelp" className="form-text text-muted">
            We'll never share your email with anyone else.
          </small>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPassword1">Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            id="exampleInputPassword1"
            onChange={onChangeDataUser}
          />
        </div>
        <button
          type="submit"
          className="btn btn-block btn-outline-dark rounded-0 mt-4 mb-2"
          onClick={validateLogin}
        >
          Ingresar
        </button>
        <button
          type="submit"
          className="btn btn-block btn-outline-secondary rounded-0 my-2"
        >
          Ingresar con Google
        </button>
        <button
          type="submit"
          className="btn btn-block btn-outline-primary my-2 rounded-0"
        >
          Ingresar con Facebook
        </button>
      </form>
    </div>
  );
};

export default SingIn;
